import { gatewayClient, createService } from './connectors/httpClient';
import { ExportJobItemType } from 'packages/variation-export/AllExports/types';

const httpClient = gatewayClient('/exports');

const exportService = createService(httpClient, (client) => ({
    getActivityFeedItems(data) {
        const searchParams = new URLSearchParams(data);

        if (searchParams.has('search')) {
            searchParams.set('query', searchParams.get('search'));
            searchParams.delete('search');
        }

        return client.get<{ items: ExportJobItemType[]; totalItems: number; message?: string }>(
            `?${searchParams.toString()}`,
        );
    },

    deleteFailedExportJob(jobId): Promise<{ status: number; json: { message?: string } }> {
        return client.delete(`/${jobId}`);
    },

    createExportJob(data) {
        return client.put<{ id: number }>('', data);
    },
}));

export default exportService;
